<template>
  <div class="scan-mask" v-show="show" @click="close">
    <div class="scan-box">
      <img :src="url"><span></span>
    </div>
  </div>
</template>
<script>
  export default{
    props: ['show','url'],
    data(){
      return {

      }
    },
    methods:{
      close(){
        this.$emit('update:show',false)
      }
    },
    created(){

    },
  }

</script>

<style scoped>
  .scan-mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    /*display: none;*/
  }
  .scan-box{
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    text-align: center;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
  .scan-box img{
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    width: auto;
  }
  .scan-box span{
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// src/components/template/imgSan.vue